import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import TaxRatesForm from "../../../components/forms/setup/taxRates/TaxRatesForm";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";

export function TaxRatesViewModel(logout, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [taxRates, setTaxRates] = useState({ data: [] });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const getTaxRates = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`taxRates`, payload);
    setLoading(false);
    if (callResult.success) {
      setTaxRates(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createTaxRate = async function (values) {
    const payload = {
      name: values.name,
      rate: parseFloat(values.rate),
    };
    let callResult = await makePostApiCall("createTaxRate", payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Tax rate added",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getTaxRates("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateTaxRate = async function (taxRate, values, index) {
    const payload = {
      id: taxRate.id,
      name: values.name,
      rate: parseFloat(values.rate),
    };
    let callResult = await makePutApiCall(`taxRate/${taxRate.id}`, payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Tax rate updated",
          SnackbarType.Success,
        ),
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getTaxRates("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddTaxRateSlideOver = () => {
    setSlideOver({
      childComponent: (
        <TaxRatesForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createTaxRate}
        />
      ),
      open: true,
    });
  };

  const viewTaxRateDetails = async function (taxRate, index) {
    setSlideOver({
      childComponent: (
        <TaxRatesForm
          taxRate={taxRate}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateTaxRate}
        />
      ),
      open: true,
    });
  };

  const deleteTaxRate = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteTaxRate/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getTaxRates(null, 0);

      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data.message,
          SnackbarType.Success,
        ),
      );
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteTaxRate = function (taxRate, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteTaxRate(taxRate.id, index)}
          message={`Are you sure you want to delete ${taxRate.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteTaxRate,
    emptyModal,
    getTaxRates,
    loading,
    taxRates,
    openAddTaxRateSlideOver,
    setEmptyModelOpen,
    setSlideOver,
    slideOver,
    viewTaxRateDetails,
  };
}
